import { Div, Button, router } from '@codesuma/baseline'
import { BackIcon } from '../back-icon'
import style from './index.module.css'

// The head a full page wears: the back chevron flush in the leading corner with
// the page's title beside it, and room under the title for the day, the country
// or whatever else names what is being looked at.
//
// One component, so the title is the same size, the same weight and in the same
// place wherever it turns up — the sheet pages, the task wizard, the event
// editor and the note page all take this rather than each building the row
// again. The row is baseline-aligned: the chevron settles on the title's own
// line rather than in the middle of the block hanging under it.
//
// The page supplies --gutter and --head-gutter; the row pulls back out of the
// page's padding to reach the screen's edges.
export interface IPageHeadOptions {
    // The editors draw a line under the row. The sheet pages do not.
    rule?: boolean
    // 'برگشت' for a page that was stepped into, 'بستن' for a sheet.
    label?: string
    // Going back, for a page that has something to say about when it may —
    // the event editor refuses while it is saving. Plain router.back() if not.
    onDismiss?: () => void
}

export const PageHead = (titleText?: string, { rule, label, onDismiss }: IPageHeadOptions = {}) => {
    const base = Div()
    base.addClass(style.base)
    if (rule) base.addClass(style.ruled)

    const dismiss = Button()
    dismiss.addClass(style.dismiss)
    dismiss.attr('aria-label', label ?? 'برگشت')
    dismiss.attr('data-ripple', '')
    dismiss.append(BackIcon())
    dismiss.on('click', () => onDismiss ? onDismiss() : router.back())
    base.append(dismiss)

    const heading = Div()
    heading.addClass(style.heading)
    base.append(heading)

    const title = Div(titleText ?? '')
    title.addClass(style.title)
    heading.append(title)

    // Made either way, but only put in the heading once it has something to
    // say — an empty one would open its own margin under the title.
    const date = Div()
    date.addClass(style.date)

    return Object.assign(base, {
        // The chevron itself, for a page with something to say about it —
        // the event editor marks it aria-disabled while it saves.
        dismiss,
        // Where the title stands, for a page that puts something else there:
        // the search page's field.
        heading,
        setTitle: (text: string) => title.text(text),
        // html rather than text: the line carries the pale-year markup.
        setDate: (html: string) => {
            date.html(html)
            if (!date.el.parentElement) heading.append(date)
        },
    })
}
